class RecentlyViewedProduct {
  constructor() {
    this.recentlyViewedProducts = JSON.parse(localStorage.getItem('sc-recently-viewed-products')) || []
    this.product = document.querySelector('#sc-recently-viewed-product-data') || null

    if (this.product) {
      this.product = JSON.parse(this.product.innerHTML)
      this.addProduct()
    }
  }

  addProduct() {
    this.isEmpty() && this.recentlyViewedProducts.push(this.product)
    !this.isEmpty() && !this.isExist(this.product.id) && (this.recentlyViewedProducts = [...this.recentlyViewedProducts, this.product])
    this.recentlyViewedProducts.length > 10 && this.removeProduct()
    localStorage.setItem('sc-recently-viewed-products', JSON.stringify(this.recentlyViewedProducts))
  }

  removeProduct() {
    this.recentlyViewedProducts.shift()
  }

  isEmpty() {
    return (
      JSON.parse(localStorage.getItem('sc-recently-viewed-products')) === null
    )
  }

  isExist(id) {
    if (this.isEmpty()) return false
    return JSON.parse(localStorage.getItem('sc-recently-viewed-products')).some((product) => product.id === id)
  }
}

new RecentlyViewedProduct()